import { get, partialRight } from 'lodash-es';

export const selectPolicyID = partialRight(get, 'policy.id');
export const selectPolicyTerms = partialRight(get, 'policy.terms');
export const selectPolicyOrigins = partialRight(get, 'policy.origins');
export const selectIsInvShippingEnabled = state => Boolean(get(state, 'policy.id'));
